/**
 * @voltxampere/ui — LM35 linear temperature sensor variant (Sprint 43-6)
 *
 * Three-terminal linear temperature sensor. Output 10 mV / °C, no
 * external calibration required. Default output 0.25 V (corresponds
 * to ~25 °C ambient). Real temperature-driven output sweep arrives
 * Sprint 47+ once the thermal model can drive component-level
 * boundary conditions.
 *
 * Reference: TI LM35DZ, TO-92. Vcc 4-30 V, output range 0-1.5 V.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorLm35 = {
    id: "lm35",
    nameTr: "LM35 (Doğrusal Sıcaklık Sensörü, 10mV/°C)",
    nameEn: "LM35 (Linear Temperature Sensor, 10mV/°C)",
    shortcut: "U",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "LM35@25°C",
    schemaType: "voltage-source",
    defaultParams: { voltage: 0.25 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-lm35.js.map